import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { DatePipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { MasterServiceService } from 'app/core/service/master-service.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { Notification } from 'app/layout/common/notifications/notifications.types';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { MatMenuModule } from '@angular/material/menu';
import { elements } from 'chart.js';
@Component({
    selector: 'notifications',
    templateUrl: './notifications.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'notifications',
    imports: [MatButtonModule, MatTooltipModule, MatMenuModule, MatIconModule, MatTooltipModule, NgTemplateOutlet, RouterLink],
    providers: [DatePipe]
})
export class NotificationsComponent implements OnInit, OnDestroy {
    @ViewChild('notificationsOrigin') private _notificationsOrigin: MatButton;
    @ViewChild('notificationsPanel') private _notificationsPanel: TemplateRef<any>;

    notifications: Notification[];
    unreadCount: number = 0;
    private _overlayRef: OverlayRef;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    inActiveNotificationss: any;
    notification: any;
    totalCount: number = 0;
    inactiveId: any;
    inActiveNotification: any;
    public isButtonDisabled = false;
    formattedDate: any;
    formattedTime: any;

    /**
     * Constructor
     */
    constructor(
        private _notificationsService: NotificationsService,
        private _overlay: Overlay,
        private _viewContainerRef: ViewContainerRef,
        private _masterService: MasterServiceService,
        public toastrService: ToastrService,
        private _matDialog: MatDialog,
        private _changeDetectorRef: ChangeDetectorRef,
        private datePipe: DatePipe,
        private _router: Router
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

        this.getNotification()
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();

        // Dispose the overlay
        if (this._overlayRef) {
            this._overlayRef.dispose();
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Open the notifications panel
     */
    openPanel(): void {
        // Return if the notifications panel or its origin is not defined
        if (!this._notificationsPanel || !this._notificationsOrigin) {
            return;
        }

        // If overlay is already attached, close it first (toggle behavior)
        if (this._overlayRef && this._overlayRef.hasAttached()) {
            this.closePanel();
            return;
        }

        // Create the overlay if it doesn't exist
        if (!this._overlayRef) {
            this._createOverlay();
        }

        // Attach the portal to the overlay
        this._overlayRef.attach(new TemplatePortal(this._notificationsPanel, this._viewContainerRef));
    }

    /**
     * Close the notifications panel
     */
    closePanel(): void {
        if (this._overlayRef && this._overlayRef.hasAttached()) {
            this._overlayRef.detach();
        }
    }

    /**
     * Mark all notifications as read
     */
    markAllAsRead(): void {
        // Mark all as read
        this._notificationsService.markAllAsRead().subscribe();
    }

    /**
     * Toggle read status of the given notification
     */
    toggleRead(notification: Notification): void {
        // Toggle the read status
        notification.read = !notification.read;

        // Update the notification
        this._notificationsService.update(notification.id, notification).subscribe();
    }

    /**
     * Delete the given notification
     */
    delete(notification: Notification): void {
        // Delete the notification
        this._notificationsService.delete(notification.id).subscribe();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Create the overlay
     */
    private _createOverlay(): void {
        // Create the overlay
        this._overlayRef = this._overlay.create({
            hasBackdrop: true,
            backdropClass: 'fuse-backdrop-on-mobile',
            scrollStrategy: this._overlay.scrollStrategies.block(),
            positionStrategy: this._overlay.position()
                .flexibleConnectedTo(this._notificationsOrigin._elementRef.nativeElement)
                .withLockedPosition(true)
                .withPush(true)
                .withPositions([
                    {
                        originX: 'start',
                        originY: 'bottom',
                        overlayX: 'start',
                        overlayY: 'top',
                        offsetX: 0,
                    },
                    {
                        originX: 'start',
                        originY: 'top',
                        overlayX: 'start',
                        overlayY: 'bottom',
                        offsetX: 0,
                    },
                ]),
        });

        // Detach the overlay from the portal on backdrop click
        this._overlayRef.backdropClick()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.closePanel();
            });
    }

    
    getNotification() {
        this._masterService.getNotification().subscribe((data) => {
            this.notifications = data.data;
            this.notifications.forEach(element=> {
                const originalDate = element.date; 
                element.formattedDate = this.datePipe.transform(originalDate, 'yyyy-MM-dd')
                element.formattedTime = this.datePipe.transform(originalDate, 'hh:mm a');
            })
            this.totalCount = data['totalRecordCount'];
            this._changeDetectorRef.detectChanges()
        });
    }
    inActiveNotifications(event) {
        this.isButtonDisabled = true;
        this.inactiveId = event.id;
        const targetPath = event?.path || '/attendance/attendance-punch-in/attendance/leaveList';
        this._masterService.inActiveNotifications(this.inactiveId).subscribe((data) => {
            this.inActiveNotification = data.data;
            if (data['status'] == 200) {
                this.closePanel();
                this.getNotification();
                this._router.navigateByUrl(targetPath);
            }
            this.isButtonDisabled = false;
        });
    }
    removeNotifications(event) {
        this.isButtonDisabled = true
        this.inactiveId = event.id
        this.getInActiveApi(this.inactiveId)
    }
    clearAllNotifications() {
        this.isButtonDisabled = true
        for (let event of this.notifications) {
            this.inactiveId = event.id
            this.getInActiveApi(this.inactiveId)
        }
    }
    getInActiveApi(inactiveId) {
        this._masterService.inActiveNotifications(inactiveId).subscribe((data) => {
            this.inActiveNotification = data.data;
            if (data['status'] == 200) {

                this.getNotification()
            }
        });
    }
}
